import { isValidMinAppCodeVersion } from "@klubora/shared";

/** Empty → `null` (clear). Digits only, 1..PG_INT_MAX. Anything else is invalid. */
export function parseMinVersionDraft(draft: string): { ok: true; value: number | null } | { ok: false } {
  const trimmed = draft.trim();
  if (trimmed === "") return { ok: true, value: null };
  if (!/^\d+$/.test(trimmed)) return { ok: false };
  const n = Number(trimmed);
  if (!isValidMinAppCodeVersion(n)) return { ok: false };
  return { ok: true, value: n };
}
